module.exports = __webpack_public_path__ + "img/cardWrap.24b6a004.png";